import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDebounce } from 'use-debounce/lib';
import { useTransactions } from '../../../../hooks/useTransactions';
import { updateTransactionFilters } from '../../../../state/actions';
import { TransfersStatus } from './components/TransfersStatus/TransfersStatus';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';
import { MobileTransactionsTable } from './components/MobileTransactionsTable/MobileTransactionsTable';
import { ActivityDetails } from './components/ActivityDetails/ActivityDetails';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { useFeatureFlag } from '../../../../../_hooks/useFeatureFlag';
import { Feature } from '../../../../../CommonSelectors/CommonArea.types';
import { TransactionsTable } from './components/TransactionsTable/TransactionsTable';

interface Props {
  managedAccountId?: string;
}

export const TransactionsTab = (props: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isEmbeddedMobile) {
    return <TransactionMobile {...props} />;
  }

  return <TransactionsDesktop {...props} />;
};

export const TransactionsDesktop = ({ managedAccountId }: Props) => {
  const showActivityDetails = useFeatureFlag(Feature.ActivityDetails);

  return (
    <>
      {!!managedAccountId && <TransfersStatus managedAccountId={managedAccountId} />}

      {showActivityDetails ? <ActivityDetails /> : <TransactionsTable />}
    </>
  );
};

export const TransactionMobile = ({ managedAccountId }: Props) => {
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm] = useDebounce(searchTerm, 1000);

  useEffect(() => {
    dispatch(updateTransactionFilters({ query: debouncedSearchTerm }));
  }, [debouncedSearchTerm, dispatch]);

  const { isFetching, hasNextPage, fetchNextPage } = useTransactions();

  return (
    <>
      <Box m="16">
        <Input
          placeholder="Search..."
          leftIcon="fa fa-search"
          onChange={({ target: { value: filter } }) => {
            setSearchTerm(filter);
          }}
          disabled={isFetching}
          value={searchTerm}
          aria-label="Search"
        />
      </Box>

      {!!managedAccountId && <TransfersStatus managedAccountId={managedAccountId} />}

      <MobileTransactionsTable />

      {hasNextPage && (
        <Box display="flex" justifyContent="center" width="100%" py="24">
          <Button
            isLoading={isFetching}
            onClick={() => {
              fetchNextPage();
            }}
          >
            Load more transactions
          </Button>
        </Box>
      )}

      <Text fontSize="small" color="neutral.400" m="24" textAlign="center">
        If you need to see additional details, please visit the web portal.
      </Text>
    </>
  );
};
